import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_COEM_ADD } from '../../../config/forms'
import CamposCoem from './CamposCoem'

class DialogoCOEMsAdd extends Component {
  render () {
    const {
      handleClose,
      handleSubmit,
      renderExportadores,
      onSelect,
      selectedExportador
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Nuevo COEM</Card.Text>
          </Card.Header>
          <Card.Body>
            <div>
              <CamposCoem 
                renderExportadores={renderExportadores}
                onSelect={onSelect}
                selectedExportador={selectedExportador}
              />
            </div>
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={handleSubmit} >Guardar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCaratula: state.comunicacionEmbarque.consultaCaratula
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_COEM_ADD,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCOEMsAdd))
